import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTableComponent } from './components/data-table/data-table.component';
import { HttpTableComponent } from './components/http-table/http-table.component';
import { TableHeaderComponent } from './components/table-header/table-header.component';
import { AddButtonComponent } from './components/add-button/add-button.component';

import * as fromComponents from './components';
import { CovalentDialogsModule } from '@covalent/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    DataTableComponent,
    HttpTableComponent,
    TableHeaderComponent,
    AddButtonComponent,
    ...fromComponents.components
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CovalentDialogsModule,
    TranslateModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    CovalentDialogsModule,
    ...fromComponents.components
  ],
  entryComponents: [...fromComponents.entryComponents]
})
export class SharedModule {}
